import { Text } from '@aws-amplify/ui-react';
import styles from './FormError.module.css';

export default function FormError({type, children}){
    return (
        <Text className={styles[type]}>{children}</Text>
    )
}